import React, { useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getScreenName } from '../../../Utils/helper';
import LactoMamaSwipeWidget from './LactoMamaSwipeWidget';
import {
  AfterImageContainer,
  BeforAfterMain,
  BeforeAndAfterContainer,
  BeforeImageContainer,
  ProgressBar,
  ResizeButtons,
  ToolTip,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

const LactoMamaBeforeAfter = (props) => {
  const { beforeAfterData, tabThemeColor, tabThemeSecondaryColor } = props;
  const [bgImageWidth, setBgImageWidth] = useState(0);
  const [showWidget, setShowWidget] = useState(true);
  const [selectedDay, setSelectedDay] = useState(0);
  const [inputVal, setInputVal] = useState(beforeAfterData?.defaultValue);
  const rangeRef = useRef();
  const afterImage = useRef();
  const MainContainer = useRef();
  const inputRange = useRef();
  const timeOutRef = useRef();
  const daySelectionText = [
    {
      day: 'Day 3',
      body: 'Boosts milk supply, body starts adjusting ',
      number: 3,
    },
    {
      day: 'Day 7',
      body: 'Better milk flow, supports digestion ',
      number: 7,
    },
    {
      day: 'Day 30',
      body: 'Milk quality improves, aids post-partum recovery, balances hormones',
      number: 30,
    },
  ];

  const progressImageList = [
    "https://images.myloapp.in/mydo_upload/mydo_upload_1763545269_1895975558.png",
    "https://images.myloapp.in/mydo_upload/mydo_upload_1763545341_1507775478.png",
    "https://images.myloapp.in/mydo_upload/mydo_upload_1763545301_833180186.png"

  ];
  const handleInputChange = (v) => {
    if (Math.abs(v - inputVal) < 10) {
      afterImage.current.classList.add('noTransition');
      rangeRef.current.classList.add('noTransition');
    } else {
      afterImage.current.classList.remove('noTransition');
      rangeRef.current.classList.remove('noTransition');
    }
    afterImage.current.style.width = `${v}%`;
    rangeRef.current.style.left = `calc(${v}% - 20px)`;
    if (showWidget) {
      setShowWidget(false);
    }
    clearTimeout(timeOutRef.current);
    setInputVal(v);
    if (v > 33 && v < 66) {
      setSelectedDay(1);
    } else if (v > 66) {
      setSelectedDay(2);
    } else {
      setSelectedDay(0);
    }

    timeOutRef.current = setTimeout(() => {
      fireEvent({
        category: 'clicked_sliding_window',
        screen_name: getScreenName(),
        section_name: 'clinical results',
        section_id: '',
        deeplink_value: null,
        shape: '',
        card_ids: '',
        send_to: '',
        finalPos: v,
      });
    }, 1000);
  };
  useEffect(() => {
    const containerWidth = MainContainer?.current?.clientWidth;
    setBgImageWidth(containerWidth);
  }, []);
  return (
    <>
      <BeforeAndAfterContainer tabThemeColor={tabThemeColor} tabThemeSecondaryColor={tabThemeSecondaryColor}>
        <div className="beforeAndAfter">
          <div className="beforeAfterContainer">
            <div className="title">Transformative Results</div>
            <div className="dayTransformations">
              <div className="counter-container">
                <img
                  src={beforeAfterData.progressImageList[selectedDay] || progressImageList[selectedDay]}
                  alt=""
                  draggable="false"
                  className="sliderImage"
                />
                <div className="number">
                  {daySelectionText[selectedDay].number}
                </div>
                <div className="text">DAYS</div>
              </div>
              <div className="dayText">
                {daySelectionText[selectedDay].body}
              </div>
            </div>
            <div className="curvContainer">
              <BeforAfterMain ref={MainContainer}>
                <BeforeImageContainer
                  bgImage={beforeAfterData?.beforeImage}
                  ref={afterImage}
                  bgImageWidth={bgImageWidth}
                  defaultWidth={beforeAfterData?.defaultValue}
                ></BeforeImageContainer>
                <AfterImageContainer
                  bgImage={beforeAfterData?.afterImage}
                  bgImageWidth={bgImageWidth}
                ></AfterImageContainer>

                <input
                  type="range"
                  value={inputVal}
                  onChange={(e) => {
                    handleInputChange(e.target.value);
                  }}
                  ref={inputRange}
                ></input>
                <ResizeButtons
                  ref={rangeRef}
                  defaultWidth={beforeAfterData?.defaultValue}
                >
                  <img
                    src={beforeAfterData?.scrolledImage}
                    alt=""
                    draggable="false"
                    className="sliderImage"
                  />
                </ResizeButtons>
                {showWidget && (
                  <>
                    <ToolTip defaultWidth={beforeAfterData?.defaultValue}>
                      <p>Move the Slider to reveal results</p>
                    </ToolTip>
                    <LactoMamaSwipeWidget
                      leftOffset={beforeAfterData?.defaultValue}
                    />
                  </>
                )}
              </BeforAfterMain>
            </div>
            <div className="footerContainer">
              <div
                className={
                  selectedDay == 0 ? 'day-box day-box-selected' : 'day-box'
                }
                onClick={(e) => {
                  handleInputChange(33);
                }}
              >
                {daySelectionText[0].day}{' '}
              </div>
              <div
                className={
                  selectedDay == 1 ? 'day-box day-box-selected' : 'day-box'
                }
                onClick={(e) => {
                  handleInputChange(63);
                }}
              >
                {daySelectionText[1].day}
              </div>
              <div
                className={
                  selectedDay == 2 ? 'day-box day-box-selected' : 'day-box'
                }
                onClick={(e) => {
                  handleInputChange(100);
                }}
              >
                {daySelectionText[2].day}
              </div>
            </div>
          </div>
          <div className="research">
            <div className="title">Backed by research</div>
            <div className="research-container">
              <div className="result">
                <div className="circle-container">
                  <ProgressBar tabThemeColor={tabThemeColor}  tabThemeSecondaryColor={tabThemeSecondaryColor} progress={95} />
                  <div className="percent">95%</div>
                </div>
                <div className="description">
                  <b>95%</b> Moms saw better milk supply in just 1 week
                </div>
              </div>
              <div className="result">
                <div className="circle-container">
                  <ProgressBar tabThemeColor={tabThemeColor}  tabThemeSecondaryColor={tabThemeSecondaryColor}  progress={92.5} />
                  <div className="percent">92.5%</div>
                </div>
                <div className="description">
                  <b>92.5%</b> Moms reported increase in their energy levels in
                  10 days
                </div>
              </div>
            </div>
            <p className="study-note">
              Based on a clinical study conducted with over
              <br /> 3000+ breastfeeding mothers.
            </p>
          </div>
        </div>
      </BeforeAndAfterContainer>

      {/* <ComparisionDesc>{beforeAfterData?.footer}</ComparisionDesc> */}
    </>
  );
};

export default LactoMamaBeforeAfter;

